//左侧菜单 json
function menuList() {
  return [
    {
      "menuId": 1,
      "image": "http://image.ahsjgs.com/images/default/overview.jpg",
      "menuName": "关于我们",
      "menuImage": "http://image.ahsjgs.com/upload/menu/menu_1.png",
      "menuUrl": "/companyOverview"
    },
    {
      "menuId": 10,
      "image": "http://image.ahsjgs.com/images/default/news.jpg",
      "menuName": "新闻中心",
      "menuImage": "http://image.ahsjgs.com/upload/menu/menu_4.png",
      "menuUrl": "/companyNews"
    },
    {
      "menuId": 14,
      "image": "http://image.ahsjgs.com/images/default/party.jpg",
      "menuName": "党群工作",
      "menuImage": "http://image.ahsjgs.com/upload/menu/menu_5.png",
      "menuUrl": "/partyMassWork"
    },
    {
      "menuId": 19,
      "image": "http://image.ahsjgs.com/images/default/culture.jpg",
      "menuName": "企业文化",
      "menuImage": "http://image.ahsjgs.com/upload/menu/menu_6.png",
      "menuUrl": "/companyCulture"
    },
    {
      "menuId": 23,
      "image": "",
      "menuName": "科技创新",
      "menuImage": "http://image.ahsjgs.com/upload/menu/menu_3.png",
      "menuUrl": "/technicalInnovation"
    },
    {
      "menuId": 28,
      "image": "",
      "menuName": "业务领域",
      "menuImage": "http://image.ahsjgs.com/upload/menu/menu_2.png",
      "menuUrl": "/businessArea"
    },
    {
      "menuId": 49,
      "image": "http://image.ahsjgs.com/images/default/recruit.jpg",
      "menuName": "人力资源",
      "menuImage": "http://image.ahsjgs.com/upload/menu/menu_7.png",
      "menuUrl": "/humanResources"
    },
    {
      "menuId": 9,
      "image": "",
      "menuName": "联系我们",
      "menuImage": "http://image.ahsjgs.com/upload/menu/menu_8.png",
      "menuUrl": "/contactUs"
    }
  ];
}

module.exports = {
  menuList
};
